import axios from "axios";
import { useState } from "react";
import { Container, Modal, Button, Spinner } from "react-bootstrap";
import { useMutation, useQuery } from "@tanstack/react-query";
import ReactReadMoreReadLess from "react-read-more-read-less";
import EditPromptFormModal from "./edit-prompt-form-modal";
import DeleteConfirmationModal from "./delete-confirmation-modal";
import { useQueryClient } from "@tanstack/react-query";

const EditPromptModal = ({ videoCode, onClose, enableChapterRegeneration, isAdmin, hasEdit }) => {
    const [promptType, setPromptType] = useState("VCHAPT");
    // const [loading, setLoading] = useState(true);
    // const [data, setData] = useState([]);

    const queryClient = useQueryClient();


    const fetchVideoPrompts = async () => {
        if (!videoCode || !promptType) return [];
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/video_prompt?video_url=https://www.youtube.com/embed/${videoCode}&prompt_type=${promptType}`)
        if (response.data?.data) {
            return response.data.data;
        } else {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/prompt?activity_id=1425&prompt_type=${promptType}`)
            if (response.data?.data) {
                const [d] = response.data.data.filter(d => !!d.active)
                return [d];
            } else {
                return [];
            }
        }
    }

    const {data: videoPrompts = [], isLoading: isVideoPromptsLoading } = useQuery ({
        queryKey: ['videoPrompts', videoCode, promptType],
        queryFn: fetchVideoPrompts,
        enabled: !!videoCode && !!promptType,
    })

    // console.log('videoPrompts',videoPrompts)

    // const fetchData = useCallback(async () => {
    //     if (!videoCode || !promptType) {
    //         return
    //     }
    //     setLoading(true);
    //     try {
    //         const response = await axios.get(`${process.env.REACT_APP_API_URL}/video_prompt?video_url=https://www.youtube.com/embed/${videoCode}&prompt_type=${promptType}`)
    //         if (response.data?.data) {
    //             setData(response.data.data);
    //         } else {
    //             const response = await axios.get(`${process.env.REACT_APP_API_URL}/prompt?activity_id=1425&prompt_type=${promptType}`)
    //             if (response.data?.data) {
    //                 const [d] = response.data.data.filter(d => !!d.active)
    //                 setData([d]);
    //             } else {
    //                 setData([]);
    //             }
    //         }
    //     } catch (err) {
    //         console.log(err)
    //     } finally {
    //         setLoading(false)
    //     }
    // }, [videoCode, promptType])


    const enableActivePrompt = async ({ prompt_type, prompt, videoCode }) => {
        await axios.post(`${process.env.REACT_APP_API_URL}/video_prompt`, {
            "prompts": [{
                "prompt_type": prompt_type,
                "prompt": prompt,
            }],
            "video_url": `https://www.youtube.com/embed/${videoCode}`
        })
    }


    const {mutate: enableActivePromptMutation}=useMutation({
        mutationFn: enableActivePrompt,
        onSuccess: () => {
            // videoPromptRefetch();
            queryClient.invalidateQueries(['videoPrompts', videoCode, promptType]);
            enableChapterRegeneration();
        },
        onError: (err) => {
            console.log(err)
        }
    })

    // const onEnable = useCallback((row) => {
    //     axios.post(`${process.env.REACT_APP_API_URL}/video_prompt`, {
    //         "prompts": [{
    //             "prompt_type": row.prompt_type,
    //             "prompt": row.prompt,
    //         }],
    //         "video_url": `https://www.youtube.com/embed/${videoCode}`
    //     })
    //         .then(() => {
    //             // fetchData();
    //             videoPromptRefetch()
    //             enableChapterRegeneration();
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //         }).finally(() => { })
    // }, [videoCode])

    const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);
    // const [deleting, setDeleting] = useState(false)

    const deletePrompt = async (id) => {
        await axios.delete(`${process.env.REACT_APP_API_URL}/video_prompt?prompt_id=${id}`)
    }

    const {mutate: deletePromptMutation, isPending: isPromptDeleting} = useMutation({
        mutationFn: deletePrompt,
        onSuccess: () => {
            // videoPromptRefetch();
            queryClient.invalidateQueries(['videoPrompts', videoCode, promptType]);
            setDeleteConfirmationId(null);
            enableChapterRegeneration();
        },
        onError: (err) => {
            console.log(err)
        },
        })

    // const onDelete = useCallback((id) => {
    //     setDeleting(true)
    //     axios.delete(`${process.env.REACT_APP_API_URL}/video_prompt?prompt_id=${id}`)
    //         .then(() => {
    //             // fetchData();
    //             videoPromptRefetch();  
    //             setDeleteConfirmationId();
    //             enableChapterRegeneration();
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //         }).finally(() => {
    //             setDeleting(false)
    //         })
    // }, [])

    // useEffect(() => {
    //     // fetchData();
    // }, [fetchData]);

    const [editPromptData, setEditPromptData] = useState()

    if (!!editPromptData) {
        return <EditPromptFormModal
            videoCode={videoCode}
            prompt={editPromptData.prompt}
            promptType={editPromptData.prompt_type}
            enableChapterRegeneration={enableChapterRegeneration}
            onClose={() => {
                setEditPromptData();
                // fetchData();
                // videoPromptRefetch();
                queryClient.invalidateQueries(['videoPrompts', videoCode, promptType]);
            }}
        />
    }

    return (
        <>
            <Modal show onHide={onClose} centered style={{ zIndex: 10000 }} dialogClassName="modal-90w">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Prompt</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ overflowY: "auto", maxHeight: "500px" }}>
                    <section className="smart-editor-wrapper pt-4">
                        <Container fluid>
                            <div className="d-flex gap-3 mb-3">
                                <label htmlFor="promptTypeChapters">
                                    <input
                                        type="radio"
                                        name="promptType"
                                        id="promptTypeChapters"
                                        className="me-1"
                                        checked={promptType === "VCHAPT"}
                                        onChange={() => setPromptType("VCHAPT")}
                                    />
                                    Guide Chapters
                                </label>
                                <label htmlFor="promptTypeNotes">
                                    <input
                                        type="radio"
                                        name="promptType"
                                        id="promptTypeNotes"
                                        className="me-1"
                                        checked={promptType === "VNOTE"}
                                        onChange={() => setPromptType("VNOTE")}
                                    />
                                    Guide Notes
                                </label>
                                <label htmlFor="promptTypeChats">
                                    <input
                                        type="radio"
                                        name="promptType"
                                        id="promptTypeChats"
                                        className="me-1"
                                        checked={promptType === "VCHATS"}
                                        onChange={() => setPromptType("VCHATS")}
                                    />
                                    Guide Chats
                                </label>
                                <label htmlFor="promptTypeContent">
                                    <input
                                        type="radio"
                                        name="promptType"
                                        id="promptTypeContent"
                                        className="me-1"
                                        checked={promptType === "VCONTENT"}
                                        onChange={() => setPromptType("VCONTENT")}
                                    />
                                    Guide Content
                                </label>
                            </div>
                            {isVideoPromptsLoading ? (
                                <div style={{ margin: "40px 0" }}>
                                    <Button
                                        variant="link"
                                        className="mt-2 mb-5 btn-spinner ms-0 text-decoration-none"
                                        disabled
                                    >
                                        <Spinner
                                            as="span"
                                            animation="grow"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className="me-1"
                                        />
                                    </Button></div>
                            ) : (
                                <table className="table table-bordered prompts-table">
                                    <thead>
                                        <tr>
                                            <th className="w-75">Prompt</th>
                                            <th>Created on</th>
                                            <th>Status</th>
                                            {(isAdmin || hasEdit) && <th>Action</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {videoPrompts?.map((row) => (
                                            <tr key={row.id}>
                                                <td>
                                                    <ReactReadMoreReadLess
                                                        charLimit={200}
                                                        readMoreText={""}
                                                        readLessText={""}
                                                    >
                                                        {row.prompt}
                                                    </ReactReadMoreReadLess>
                                                </td>
                                                <td>
                                                    {row.created_on &&
                                                        new Date(row.created_on).toLocaleString()}
                                                </td>
                                                <td>
                                                    {row.active ?
                                                        <div style={{
                                                            padding: '4px 8px',
                                                            background: '#B2AC5F',
                                                            borderRadius: '4px',
                                                            color: 'white',
                                                            width: 'fit-content'
                                                        }}>Active</div> :
                                                        <div style={{
                                                            padding: '4px 8px',
                                                            borderRadius: '4px',
                                                            background: '#C4C4C4',
                                                            width: 'fit-content'
                                                        }}>Inactive</div>}
                                                </td>
                                                {(isAdmin || hasEdit) &&
                                                <td>
                                                    <div className="d-flex gap-4 align-item-center">
                                                        <div>
                                                            <img
                                                                style={{
                                                                    cursor: "pointer",
                                                                }}
                                                                src="/images/edit.svg"
                                                                alt="edit"
                                                                onClick={() => setEditPromptData(row)}
                                                            />
                                                        </div>
                                                        <div>
                                                            <img
                                                                style={{
                                                                    cursor: "pointer",
                                                                    opacity: row.active ? 0.3 : 1,
                                                                    pointerEvents: row.active ? "none" : "inherit",
                                                                }}
                                                                src="/images/delete-grey.svg"
                                                                alt="delete"
                                                                onClick={() => setDeleteConfirmationId(row.id)}
                                                            />
                                                        </div>
                                                        <div>
                                                            <img
                                                                style={{
                                                                    cursor: "pointer",
                                                                    opacity: row.active ? 0.3 : 1,
                                                                    pointerEvents: row.active ? "none" : "inherit",
                                                                }}
                                                                src="/images/tick.svg"
                                                                alt="tick"
                                                                onClick={() => enableActivePromptMutation({ ...row, videoCode })}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                }
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </Container>
                    </section>
                </Modal.Body>
            </Modal >
            {deleteConfirmationId !== null &&
                <DeleteConfirmationModal 
                    loading={isPromptDeleting}
                    onClose={() => setDeleteConfirmationId(null)}
                    onConfirm={() => deletePromptMutation(deleteConfirmationId)}
                />
            }
        </>
    );
}

export default EditPromptModal;